
export const ADD_MAIN_MODULE = 'ADD_MAIN_MODULE';

type UserActionType = typeof ADD_MAIN_MODULE;
export interface UserAction {
  type: UserActionType;
  payload: any;
}


export interface UserLoginState {
  password: string,
  username: string
}
export interface Module {
  key: number;
  id: string;
  keyModule: string;
  link: string;
  label: string;
  icon: string;
  description: string;
  createdAt: string;
}
export interface UserActionRequest {
  mainModuleId: string;

}
export interface CredentialsRequest {
  username: string | null,
  password: string | null
}
export interface MainModuleDataType {
  id: string;
  key: string;
  label: string;
  url: string;
  icon: string;
  xTenant: string;
  urlModule: string;
  rolId: string;
  portal:boolean;
  created_at: Date;
  description:string;
}
export interface CredentialsRequest {
  username: string | null,
  password: string | null
}

export interface User {
  id?: string; // uuid
  identification: string; // char(20)
  firstName: string; // varchar(60)
  lastName: string; // varchar(60)
  email: string; // varchar(125)
  phone: string; // char(15) 
  status?: string; // varchar(15)
  created_at?: string; // timestamp with time zone (ISO string)
  updated_at?: string | null; // timestamp with time zone (nullable)
  type: string; // varchar(25)
  rolName?: string; // varchar(25)
  fullName?:string;
  rol?: string; // varchar(25)
  groupId: string; // varchar(25)
  commisionRequest:Comission[];
  specialityId?:string;
  centerId:string[];
  observation?:string;
  medicInformation?:MedicInformation;

}
export interface MedicInformation {
  id: string; // uuid
  userId: string; // varchar(25)
  specialityId: string; 
  description?: string; 
  specialityName:string
}
export interface Group {
  id: string; // uuid
  name: string; // varchar(25)
  description: string; // varchar(255)
  created_at: string; // timestamp with time zone (ISO string)
  updated_at?: string | null; // timestamp with time zone (nullable)
}



export interface Comission {
  id?: string; // uuid
  commissionPercentage: number; // varchar(25)
  observation?: string; // varchar(255)  
  service?: string; // varchar(255)  
  serviceId?: string; // varchar(255)  
  created_at?: string; // timestamp with time zone (ISO string)
 
}


export interface Speciality {
  id?: string; // uuid
  name: string; // varchar(25)
  status?: string; // varchar(25)
  observation?: string; // varchar(255)  
  created_at?: string; // timestamp with time zone (ISO string)
  updated_at?: string; // timestamp with time zone (ISO string)
  defaultSections?: MedicalRecordSection[];
 
}

export interface MedicalRecordSection {
  id?: string;
  name: string;
  description?: string | null;
  status?: string | null;
  canDisable?: boolean;
}

export interface MedicalRecordSectionRequest {
  id?: string | null;
  name: string;
  description?: string | null;
  status?: string | null;
}

export interface SpecialtyDefaultSectionsRequest {
  specialityId: string;
  medicalRecordSectionIds: string[];
}

export interface UserInformation {
  firstName: string;
  lastName: string;
  fullName: string;
  identification: string;
  email: string;
  userId: string;  // Guid en C# se representa como string en TS
  groupId: string; // igual que arriba
  groupName:string;
}

export interface ProfileResponse {
  userId?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  identification?: string;
  email?: string;
  phone?: string;
  rolName?: string;
  roleName?: string;
  groupName?: string;
  organizationName?: string;
  tenant?: string;
  planName?: string;
  status?: string;
  [key: string]: any;
}

export interface FiscalProfileForm {
  organizationName: string;
  ruc: string;
  legalName: string;
  tradeName?: string;
  fiscalAddress: string;
  email: string;
  phone: string;
  accountingRequired: boolean;
  taxpayerCategory?: string;
  isSpecialTaxpayer: boolean;
  specialTaxpayerNumber?: string;
  isWithholdingAgent: boolean;
  withholdingAgentResolution?: string;
  taxRegime: string;
  sriEnvironment?: 'PRUEBAS' | 'PRODUCCION';
  status: 'ACTIVO' | 'INACTIVO';
}

export interface FiscalProfileResponse extends FiscalProfileForm {
  id: string;
  organizationId: string;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface OrganizationFiscalSourceResponse {
  organizationId: string;
  organizationName: string;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
  tenant?: string;
  status?: string;
}

export interface RuntimeEnvironmentResponse {
  environment: 'DEVELOP' | 'PRODUCTION';
  label: string;
  sriEnvironment: 'PRUEBAS' | 'PRODUCCION';
}

export interface SalesDocumentListItem {
  id: string;
  documentSeries: string;
  documentNumber: string;
  status: string;
  total: number;
  issueDate: string;
  turnId?: string | null;
  billingMode: 'TURNO' | 'DIRECTA' | string;
  clientIdentificationType: string;
  clientIdentificationNumber: string;
  clientName: string;
  paidAmount: number;
  paymentStatus: 'PENDIENTE' | 'PARCIAL' | 'PAGADO' | string;
}

export interface SalesDocumentListResponse {
  items: SalesDocumentListItem[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export interface ClientDataLookupResponse {
  id: string;
  identificationType: string;
  identificationNumber: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  address?: string | null;
}

export interface FiscalEstablishment {
  id: string;
  organizationFiscalProfileId: string;
  msIdentityCenterId: string;
  msIdentityCenterName: string;
  code: string;
  isMatrix: boolean;
  status: string;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface FiscalPointOfEmission {
  id: string;
  organizationFiscalEstablishmentId: string;
  code: string;
  description?: string | null;
  status: string;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface FiscalBillingDocumentType {
  id: string;
  billingDocumentTypeId: string;
  code: string;
  name: string;
  sriCode: string;
  status: string;
}

export interface BillingDocumentType {
  id: string;
  code: string;
  name: string;
  sriCode: string;
  status: string;
}

export interface OrganizationBillingDocumentType {
  id: string;
  organizationFiscalProfileId: string;
  billingDocumentTypeId: string;
  code: string;
  name: string;
  sriCode: string;
  status: string;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface PaymentMethodCatalogue {
  id: string;
  code: string;
  sriCode: string;
  name: string;
  category: string;
  requiresReference: boolean;
  status: string;
}

export interface DocumentRefactoringReason { id: string; code: string; description: string; allowedMethod: string; status: string; createdAt?: string; updatedAt?: string | null; }
export interface DocumentRefactoringPolicy { id: string; code: string; name: string; withinCancellationWindowMethod: string; outsideCancellationWindowMethod: string; cancellationWindowMode: string; cancellationDeadlineDay: number; effectiveFrom: string; effectiveTo?: string | null; status: string; createdAt?: string; updatedAt?: string | null; }
export interface TaxRateDefinition { id: string; code: string; name: string; taxType: string; taxTreatment: string; rate?: number | null; sriTaxCode?: string | null; sriPercentageCode?: string | null; status: string; createdAt?: string; updatedAt?: string | null; }
export interface TaxGlobalSchedule { id: string; taxRateDefinitionId: string; effectiveFrom: string; effectiveTo?: string | null; status: string; createdAt?: string; updatedAt?: string | null; }
export interface OrganizationTaxSchedule { id: string; taxRateDefinitionId: string; taxRateCode: string; taxRateName: string; taxTreatment: string; rate?: number | null; sriTaxCode?: string | null; sriPercentageCode?: string | null; effectiveFrom: string; effectiveTo?: string | null; status: string; }
export interface EffectiveTaxRate { id: string; code: string; name: string; taxTreatment: string; rate?: number | null; sriTaxCode?: string | null; sriPercentageCode?: string | null; isOrganizationDefault: boolean; source: 'GLOBAL' | 'ORGANIZACION'; }
export interface OrganizationTaxConfigurationResponse { definitions: TaxRateDefinition[]; schedules: OrganizationTaxSchedule[]; effectiveRates: EffectiveTaxRate[]; evaluationDate: string; }
export interface OrganizationSigningConfiguration { id: string; sriEnvironment: string; certificateSerial: string; certificateSubject?: string | null; validFrom: string; validTo: string; isDefault: boolean; status: string; isCurrentlyValid: boolean; storedSecurely: boolean; }
export interface OrganizationSchemaAssignment { id: string; electronicSchemaVersionId: string; billingDocumentTypeCode: string; billingDocumentTypeName: string; version: string; sriEnvironment: string; enabledFrom: string; enabledTo?: string | null; isDefault: boolean; status: string; }
export interface ElectronicDocumentReadiness { sriCode: string; name: string; ready: boolean; missingReason?: string | null; }
export interface OrganizationElectronicConfiguration { runtimeEnvironment: string; sriEnvironment: string; ready: boolean; missingRequirements: string[]; availableSchemaVersions: ElectronicSchemaVersion[]; schemaAssignments: OrganizationSchemaAssignment[]; signingConfigurations: OrganizationSigningConfiguration[]; documentTypes: ElectronicDocumentReadiness[]; }
export interface ElectronicSchemaVersion { id: string; billingDocumentTypeId: string; billingDocumentTypeCode: string; billingDocumentTypeName: string; version: string; sriEnvironment: string; xsdNamespace: string; xsdStorageKey: string; xmlTemplateKey: string; rideTemplateKey: string; effectiveFrom: string; effectiveTo?: string | null; status: string; createdAt?: string; updatedAt?: string | null; }

export interface OrganizationPaymentMethod {
  id: string;
  organizationFiscalProfileId: string;
  paymentMethodCatalogueId: string;
  code: string;
  sriCode: string;
  name: string;
  category: string;
  requiresReference: boolean;
  isDefault: boolean;
  displayOrder: number;
  status: string;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface FiscalSequence {
  id: string;
  fiscalPointOfEmissionId: string;
  organizationBillingDocumentTypeId: string;
  billingDocumentTypeCode: string;
  billingDocumentTypeName: string;
  sriCode: string;
  lastNumber: number;
  status: string;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface FiscalConfigurationResponse {
  profile: FiscalProfileResponse;
  establishments: FiscalEstablishment[];
  pointsOfEmission: FiscalPointOfEmission[];
  sequences: FiscalSequence[];
  billingDocumentTypes: FiscalBillingDocumentType[];
}

export interface PathologicalHistory {
    id: string;
    name: string;
    description?: string;
    createdAt: string;
}

export interface OrganizationRefactoringReason {
  id: string;
  documentRefactoringReasonId: string;
  code: string;
  description: string;
  allowedMethod: string;
  customDescription?: string | null;
  requiresObservation: boolean;
  status: string;
}

export interface DocumentRefactoringPreview {
  salesDocumentId: string;
  documentNumber: string;
  issueDate: string;
  cancellationDeadline: string;
  evaluationDate: string;
  isWithinCancellationWindow: boolean;
  method: 'ANULACION' | 'NOTA_CREDITO';
  paidAmount: number;
  paymentDispositionOptions: string[];
  notice: string;
}

export interface ClientData {
  id?: string | null;
  ruc: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface OrganizationPaymentMethod {
  id: string;
  name: string;
}

export interface ExpenseCategory {
  id?: string | null;
  name: string;
  description?: string | null;
  status: 'ACTIVO' | 'INACTIVO';
  createdAt?: string;
  updatedAt?: string | null;
}

export interface Expense {
  id?: string | null;
  expenseCategoryId: string;
  expenseCategoryName?: string;
  organizationId: string;
  organizationName?: string;
  number?: string | null;
  providerName: string;
  description: string;
  expenseDate: string;
  paymentDate?: string | null;
  status: 'PENDIENTE' | 'PAGADO' | 'ANULADO';
  paymentMethod?: string | null;
  currency: string;
  subtotal: number;
  iva: number;
  total?: number;
  documentUrl?: string | null;
  notes?: string | null;
  userId?: string | null;
  userName?: string | null;
  paymentSource?: 'EMPRESA' | 'SOCIO' | 'TRABAJADOR' | 'TERCERO';
  reimbursement?: ExpenseReimbursement | null;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface ExpenseReimbursement {
  id?: string | null;
  expenseId?: string | null;
  userId: string;
  userName?: string | null;
  amount: number;
  paidAmount: number;
  pendingAmount?: number;
  status?: 'PENDIENTE' | 'PARCIAL' | 'PAGADO' | 'ANULADO';
  paymentDate?: string | null;
  notes?: string | null;
}

export interface FinancialMetricsPeriod {
  period: string;
  income: number;
  expenses: number;
  profit: number;
}

export interface ExpenseByCategory {
  categoryId: string;
  categoryName: string;
  total: number;
}

export interface FinancialMetrics {
  income: number;
  expenses: number;
  profit: number;
  profitMargin: number;
  pendingExpenses?: number;
  reimbursementDebt?: number;
  reimbursementPaid?: number;
  series: FinancialMetricsPeriod[];
  expensesByCategory: ExpenseByCategory[];
}

export interface ExpenseOptions {
  providers: string[];
  paymentMethods: string[];
}

export interface BlobFileInfo {
  fileName: string;
  containerName: string;
  contentType: string;
  fileSize: number;
  expiresOn: string;
  sasUrl: string;
}

export interface OrganizationSearch {
  id: string;
  name: string;
  tenant: string;
  status: string;
  email: string;
  phone: string;
  address?: string | null;
}

export interface ContractExpiring {
  contractId: string;
  organizationId: string;
  organizationName: string;
  organizationPhone?: string | null;
  phone?: string | null;
  planId: string;
  planName: string;
  contractNumber: number;
  startDate: string;
  endDate: string;
  status: string;
  billingCycle: string;
  discountPercentage?: number | null;
  totalPrice: number;
  currency: string;
  billingEmail: string;
  subscriptionStatus?: string | null;
  trialStartAt?: string | null;
  trialEndAt?: string | null;
  nextBillingAt?: string | null;
  cardTokenId?: string | null;
  daysToExpire: number;
  hasSalesDocument: boolean;
  hasPendingSalesDocument: boolean;
  hasPaidSalesDocument: boolean;
  lastSalesDocumentId?: string | null;
  lastSalesDocumentNumber?: string | null;
  lastSalesDocumentStatus?: string | null;
}

export interface SalesDocumentFileRequest {
  base64File: string;
  fileName: string;
}

export interface SalesDocumentPaymentMethodRequest {
  id?: string | null;
  organizationPaymentMethodId: string;
  amount: number;
}

export interface ContractSalesDocumentRequest {
  number: string;
  planId?: string | null;
  billingPeriods: number;
  clientData: ClientData;
  status: 'PAGADO' | 'PENDIENTE';
  statusSri: 'PENDIENTE' | 'MANUAL' | 'SERVICIO';
  integrationSri: boolean;
  authorization?: string | null;
  documentFile?: SalesDocumentFileRequest | null;
  rideFile?: SalesDocumentFileRequest | null;
  paymentMethods: SalesDocumentPaymentMethodRequest[];
}

export interface SalesDocumentPaymentMethodResponse {
  organizationPaymentMethodId: string;
  name: string;
  amount: number;
}

export interface OrganizationSalesDocument {
  id: string;
  organizationId: string;
  organizationName?: string | null;
  planId?: string | null;
  planName?: string | null;
  number: string;
  currency: string;
  documentType: string;
  status: string;
  documentUrl?: string | null;
  clientDataId: string;
  clientRuc: string;
  clientName: string;
  ride?: string | null;
  integrationSri: boolean;
  statusSri: string;
  paymentDate?: string | null;
  subtotal: number;
  iva: number;
  total: number;
  authorization?: string | null;
  createdAt: string;
  updatedAt: string;
  paymentMethods: SalesDocumentPaymentMethodResponse[];
}

export interface OrganizationLegalDocument {
  id: string;
  legalDocumentId: string;
  code: string;
  name: string;
  url: string;
  description?: string | null;
  status: string;
  optional: boolean;
  current: boolean;
  version: string;
  contentText: string;
  contentType: 'TEXT' | 'HTML';
  contentHash: string;
  effectiveFrom: string;
  acceptedAt: string;
}

export interface LegalDocument {
  id?: string | null;
  createdAt?: string;
  code: string;
  name: string;
  url: string;
  description?: string | null;
  status: 'ACTIVO' | 'INACTIVO';
  optional: boolean;
  current: boolean;
  version: string;
  contentText?: string;
  contentType?: 'TEXT' | 'HTML';
  contentHash?: string;
  effectiveFrom: string;
}

export interface Plan {
  id?: string | null;
  code?: string | null;
  name: string;
  description?: string | null;
  status: 'ACTIVO' | 'INACTIVO';
  type: string;
  price: number;
  billingCycle: 'MENSUAL' | 'ANUAL' | 'DIAS';
  billingPeriodDays?: number | null;
  trialDays?: number | null;
  trialValidationAmount?: number | null;
  visible?: boolean | null;
  rolSystems?: PlanRolSystem[];
  services?: PlanService[];
  featureFlagsResponse?: PlanFeatureFlags | null;
}

export interface PlanRequest {
  id?: string | null;
  code?: string | null;
  name: string;
  description?: string | null;
  status?: 'ACTIVO' | 'INACTIVO';
  type: string;
  price: number;
  billingCycle: 'MENSUAL' | 'ANUAL' | 'DIAS';
  billingPeriodDays?: number | null;
  trialDays?: number | null;
  trialValidationAmount?: number | null;
  visible?: boolean | null;
  rolSystemIds?: string[];
  rolSystemCapacities?: PlanRoleCapacityRequest[];
  serviceIds?: string[];
  featureFlags?: PlanFeatureFlags | null;
}

export interface PlanFeatureFlags {
  maxSpecialities?: number | null;
  maxPatients?: number | null;
  maxCenters?: number | null;
  maxAppointments?: number | null;
  maxEmails?: number | null;
  maxAttentions?: number | null;
  maxStorageBytes?: number | null;
}

export interface PlanRoleCapacityRequest {
  rolSystemId: string;
  maxUsers?: number | null;
    includedUsers?: number;
    additionalLicensePrice?: number;
}

export interface PlanRolSystem {
  rolSystemId: string;
  rolId: string;
  systemId: string;
  systemName?: string;
  systemLabel?: string;
  rolName: string;
  maxUsers?: number | null;
    includedUsers?: number;
    additionalLicensePrice?: number;
}

export interface PlanService {
  id: string;
  name: string;
  category: string;
  resourceType?: string;
  hasProducts?: boolean;
}

export interface ManagedService {
  id?: string | null;
  name: string;
  description?: string | null;
  observation?: string | null;
  category: string;
  resourceType?: string | null;
  status: 'ACTIVO' | 'INACTIVO';
}

export interface CatalogProduct {
  id: string;
  serviceId: string;
  service: string;
  serviceCategory: string;
  code: string;
  description: string;
  genericDescription: string;
  commercialName: string;
  status: 'ACTIVO' | 'INACTIVO';
  isOrganizationProduct: boolean;
}

export interface UpdateOrganizationProductRequest {
  id: string;
  description: string;
  genericDescription: string;
  commercialName: string;
  status: 'ACTIVO' | 'INACTIVO';
}

export interface CatalogProductManagementRequest {
  id?: string | null;
  serviceId: string;
  code?: string | null;
  description: string;
  genericDescription: string;
  commercialName: string;
  status: 'ACTIVO' | 'INACTIVO';
}

export interface ProductPackage {
  id?: string | null;
  specialityId?: string | null;
  code: string;
  name: string;
  description?: string | null;
  status: 'ACTIVO' | 'INACTIVO';
  products: CatalogProduct[];
}

export interface ProductPackageRequest {
  id?: string | null;
  specialityId?: string | null;
  code: string;
  name: string;
  description?: string | null;
  status: 'ACTIVO' | 'INACTIVO';
  productIds: string[];
}

export interface OrganizationProductRequest {
  serviceId: string;
  description: string;
  genericDescription: string;
  commercialName: string;
}

export interface TbcPortalUser {
  id?: string | null;
  dni: string;
  fullName: string;
  email?: string | null;
  phone?: string | null;
  observation?: string | null;
  status: 'ACTIVO' | 'INACTIVO' | 'BLOQUEADO';
  type?: string;
  organizationId?: string;
  rolSystemId?: string | null;
  userRolSystemId?: string | null;
  rolName?: string | null;
  rolId?: string | null;
  systemLabel?: string | null;
  systemId?: string | null;
  xTenant?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface TbcPortalUserRequest {
  id?: string | null;
  dni: string;
  fullName: string;
  email?: string | null;
  phone?: string | null;
  observation?: string | null;
  status?: 'ACTIVO' | 'INACTIVO' | 'BLOQUEADO';
  rolSystemId: string;
}

export type CompanyUserType = 'SOCIO' | 'TRABAJADOR' | 'PROVEEDOR' | 'CONTRATISTA' | 'OTRO';
export type CompanyUserCategory = 'NOMINA' | 'SERVICIOS_PROFESIONALES' | 'EXTERNO' | 'PROVEEDOR' | 'SOCIO';

export interface CompanyUser {
  id?: string | null;
  organizationId?: string;
  organizationName?: string;
  dni: string;
  fullName: string;
  email?: string | null;
  phone?: string | null;
  type: CompanyUserType;
  category?: CompanyUserCategory | null;
  observation?: string | null;
  status: 'ACTIVO' | 'INACTIVO' | 'BLOQUEADO';
  createdAt?: string;
  updatedAt?: string | null;
}

export interface CompanyUserRequest {
  id?: string | null;
  organizationId?: string | null;
  dni: string;
  fullName: string;
  email?: string | null;
  phone?: string | null;
  type: CompanyUserType;
  category?: CompanyUserCategory | null;
  observation?: string | null;
  status?: 'ACTIVO' | 'INACTIVO' | 'BLOQUEADO';
}
